module.exports = __webpack_public_path__ + "static/media/HYFI-BNB.1f5d3163.svg";